import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import routes from './routes'
import Notify from 'quasar/src/plugins/Notify.js';
import { avoidIfLoggedIn, preventRedirects } from '@/plugins/urlPaths'

Vue.use(VueRouter)

const router = new VueRouter({
    scrollBehavior: (to, from, savedPosition) => {
        // savedPosition is only available for popstate navigations.
        if (savedPosition) return savedPosition

        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        if (to.params.savePosition) return {}

        // scroll to anchor by returning the selector
        if (to.hash) {
            let position = { selector: to.hash }

            // specify offset of the element
            // if (to.hash === '#anchor2') {
            //   position.offset = { y: 100 }
            // }
            return position
        }

        if (to.path == from.path) return {}

        // scroll to top by default
        return { x: 0, y: 0 }
    },
    routes,
    mode: "history",
    base: process.env.VUE_APP_BASEURL,
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const { requiresAuth } = to.meta
    const currentUser = store.getters.authUser
    const isLoggedInAndTokenValid = () => {
        var token = JSON.parse(localStorage.getItem('token')) || null
        if (token) {
            var now = new Date()
            var expires = new Date(token.expires_in)

            if (expires < now) {
                store.dispatch('logout')
                Notify.create({
                    badgeClass: 'hidden',
                    type: 'info',
                    message: 'Your session has ended, please sign in again'
                })
                return false
            }
            else {
                return true
            }
        }
        else {
            return false
        }
    }
    const isLoggedIn = isLoggedInAndTokenValid()

    if (preventRedirects.includes(from.path)) {
        return
    }

    if (isLoggedIn && avoidIfLoggedIn.includes(to.path)) {
        return next({ path: '/' })
    }

    if (requiresAuth) {
        if (isLoggedIn && currentUser && currentUser.emailConfirmed == 'False') {
            return next({ name: '/account/confirm', query: { userId: currentUser.id, returnUrl: to.path } })
        }

        if (!currentUser || !isLoggedIn) {
            // not logged in and page requires authorization so redirect to home page
            return next({ name: '/login', params: { returnUrl: to.path } })
        }
    }

    // Remove current meta tags
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach(el => el.parentNode.removeChild(el));

    // Find the meta information for route
    const routeMetaInfo = to.matched.slice().reverse().find(r => r.meta);

    // If the route has no meta information, continue
    if (!routeMetaInfo) return next();

    // Set the title from the meta information
    if (routeMetaInfo.meta.title) {
        document.title = routeMetaInfo.meta.title;
    }

    // If there are meta tags in the meta information, add the meta tags
    if (routeMetaInfo.meta.metaTags) {
        routeMetaInfo.meta.metaTags.forEach(tagDef => {
            const tag = document.createElement('meta');
            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });
            tag.setAttribute('data-vue-router-controlled', '');
            document.head.appendChild(tag);
        });
    }

    next()
    store.commit('update_isSectionTableSm', false)
    store.commit('set_showReinstatementCostDialog', false)
})

router.afterEach((to) => {
    const canonicalLink = document.querySelector("link[rel='canonical']");

    const { protocol, host } = window.location;

    // Add trailing slash to path if it doesn't already have one
    let path = to.path.endsWith('/') ? to.path : to.path + '/';

    // Adding query string back in if it exists
    const queryString = to.query && Object.keys(to.query).length ? '?' + new URLSearchParams(to.query).toString() : '';

    let baseURL = process.env.VUE_APP_BASEURL == '/' ? '' : '/AvenirWeb'

    const canonicalUrl = `${protocol}//${host}${baseURL}${path}${queryString}`;

    if (canonicalLink) {
        canonicalLink.setAttribute('href', canonicalUrl);
    } else {
        const link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', canonicalUrl);
        document.head.appendChild(link);
    }
});

export default router
